import { useState } from "react";
import { MessageSquarePlus } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import FeedbackModal from "@/components/FeedbackModal";

export default function FeedbackButton() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  if (!user) return null;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-20 right-4 md:bottom-6 md:right-6 z-30 flex items-center gap-2 p-3 md:px-4 md:py-3 bg-[#CA8A04] hover:bg-[#B8860B] text-white rounded-full md:rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 group"
        aria-label="Open feedback"
      >
        <MessageSquarePlus className="h-5 w-5" />
        <span className="hidden md:inline text-sm font-medium">Community Feedback</span>
      </button>

      <FeedbackModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
